import React, { useContext, useEffect } from 'react'

import SearchBarSkeleton from '../components/SearchBar/SearchBarSkeleton'
import ValidationContainer from '../components/SearchBar/ValidationContainer'
import Collections from '../components/shared/Collections/Collections'
import Footer from '../components/shared/Footer'
import { DataContext } from '../context/DataContext'
import { useCompanyApi } from '../hooks/useCompanyApi'

const SearchBar: React.FC = () => {
  const {
    showCollections,
    loadingCompanyData
  } = useContext(DataContext)
  const { fetchData } = useCompanyApi()

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <div className={`min-w-screen min-h-screen ${showCollections ? 'grid portrait:grid-cols-1 grid-cols-2' : 'flex flex-col items-center justify-center'} pt-10 gap-2 md:px-28 md:pb-32`}>
      {loadingCompanyData ?
        <div className={`${showCollections ? 'w-full mb-4' : 'landscape:w-3/5 w-full landscape:h-full'}`}>
          <SearchBarSkeleton />
        </div> : <>
        <div className={`${showCollections ? 'w-full mb-4' : 'landscape:w-3/5 w-full landscape:h-full'}`}>
          <ValidationContainer />
        </div>
        {showCollections && (
          <div className='w-full min-w-0 h-full flex flex-col'>
            <Collections />
          </div>
        )}
      </>}

      <div className={`landscape:hidden portrait:mb-8 ${loadingCompanyData ?? 'portrait:mt-20'} flex items-center justify-center`}>
        <Footer />
      </div>
    </div>
  )
}

export default SearchBar
